export const isProductionHostname = (
  location: Pick<Location, 'hostname'> = window.location,
) => location.hostname === 'triviamap.jp';
